import styled, { css, keyframes } from "styled-components";

interface ChatbotIframeProps {
  device: string;
  pageName?: string;
}

interface ChatbotIconProps {
  pageName?: string;
  showAnimation: boolean;
  chatbotBottomMargin?: number;
}

const getBottomPosition = (props: ChatbotIframeProps) => {
  if (props.device === "lg") {
    if (props.pageName === "LISTING") {
      return "112px";
    }
    return "25px";
  } else if (props.device === "sm") {
    return "0";
  } else {
    return "10px";
  }
};

export const myraAnimation = keyframes`
  0%   { right: calc(50% - 30px); }
  100% { right: 90px; }
`;

export const ChatbotIcon = styled.img<ChatbotIconProps>`
  position: fixed;
  bottom: ${(props) => `${props.chatbotBottomMargin}px`};
  right: 40px;
  z-index: 1000;
  width: 60px;
  height: 60px;
  cursor: pointer;
  ${(props) =>
    props.showAnimation &&
    css`
      animation: ${myraAnimation} 3s ease-out;
    `}
`;

export const ChatbotIframe = styled.iframe<ChatbotIframeProps>`
  height: ${(props) => (props.device == "lg" ? "554px" : "85vh")};
  width: ${(props) => (props.device == "lg" ? "360px" : "100%")};
  bottom: ${(props) => getBottomPosition(props)};
  right: ${(props) => (props.device == "lg" ? "20px" : "0")};
  position: fixed;
  z-index: 1001;
  box-shadow: none;
`;
